import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonBlock = styled.div<{ $height?: string; $width?: string; $radius?: string }>`
  height: ${({ $height }) => $height || '16px'};
  width: ${({ $width }) => $width || '100%'};
  border-radius: ${({ $radius }) => $radius || '4px'};
  background-color: ${({ theme }) => theme.colors.Grey3};
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.Grey3} 0px,
    ${({ theme }) => theme.colors.Grey1} 40px,
    ${({ theme }) => theme.colors.Grey3} 80px
  );
  background-size: 200px 100%;
  background-repeat: no-repeat;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;
